import styled, { css } from 'styled-components';
import { colors } from '../../constants/colors';
import { CheckIcon } from '../icons/CheckIcon';
import { CrossIcon } from '../icons/CrossIcon';

export const StyledPlansOptionsTable = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 8px;
`;

export const StyledOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 48px;
  max-width: 1200px;

  svg {
    ${(props) =>
      props.isDisabled &&
      css`
        fill: ${colors.lightGrey3};
      `};
  }
`;
export const StyledOptionHeader = styled(StyledOptionContainer)`
  background-color: ${colors.lightGrey2};
  padding: 32px 48px;
  border-radius: 8px;
  font-weight: bold;
`;
export const StyledCell = styled.div`
  position: relative;
  min-width: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  sup {
    white-space: nowrap;
  }

  ${(props) => props.isDisabled && `color: ${colors.lightGrey3}`};

  &:first-child {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    width: 320px;
  }
  &:nth-child(n + 2) {
    font-weight: bold;
  }
`;
export const StyledCheckIcon = styled(CheckIcon)`
  width: 14px;
  height: 14px;
  fill: ${colors.green};
`;

export const StyledCrossIcon = styled(CrossIcon)`
  width: 11px;
  height: 11px;
`;

export const StyledOptionGroup = styled.div`
  margin: auto;
  max-width: 1200px;
  width: 100%;

  ${({ sticky }) => 
    sticky && css`
      position: sticky;
      top: 70px; // site header
      z-index: 1;
    `};

  ${({ withSeparator = true }) =>
    withSeparator &&
    css`
      border-bottom: 1px solid ${colors.lightGrey};
    `}
`;

export const StyledOptionGroupHeader = styled.div`
  text-align: left;
  color: ${colors.yellow};
  font-weight: bold;
  padding: 48px 48px 24px;
  font-size: 1.2em;
`;
